export default "__VITE_ASSET__CG74y8b1__"